/**
 * Resolution rule for the "Company Settings: Manage Scheduling & Rostering Settings"
 * user permission (HERA-8542).
 *
 * Scheduling & Rostering is gated by a tenant feature flag pair. The user-level
 * permission must therefore follow the tenant module state when Full Admin is
 * revoked:
 *
 *   module enabled  -> granted, in line with every other permission
 *   module disabled -> denied, unless an administrator had explicitly granted it
 *                      before the current form session began
 *
 * Without the second clause, granting and then revoking Full Admin would leave
 * configuration for an unreleased feature switched on and persist it on save.
 *
 * The flag pairing matches the menu gate in Settings.vue (`hasSchedulingRostering`)
 * and the tenant-level derivation in TenantDetail.vue, so form state and menu
 * visibility stay consistent.
 */
export function isSchedulingRosteringModuleEnabled(featurePermissions) {
    const flags = featurePermissions || {}
    return Boolean(
        flags.featureAccessSchedulingAndRostering &&
        flags.featureEnabledSchedulingAndRostering
    )
}

/**
 * @param {object|null} featurePermissions tenant feature flags, as returned by
 *        getTenantFeaturePermissions()
 * @param {boolean|null|undefined} priorStoredValue the load-time snapshot of the
 *        user's stored permission, taken after null-normalization
 * @returns {boolean}
 */
export function resolveSchedulingRosteringPermission(featurePermissions, priorStoredValue) {
    if (isSchedulingRosteringModuleEnabled(featurePermissions)) return true
    return priorStoredValue === true
}
